import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cartService from 'services/CartService'
import { Button } from 'ui/atoms'
import { setQueryInUrl } from 'utils'

// FIXME "children" are not supported in the underlaying button component
export default function AddToCartButton({ children, className, items, href, onClick, ...props }) {
  const [busy, setBusy] = useState(false)

  const onClickHandler = e => {
    if (busy) return
    setBusy(true)

    cartService
      .addItems(items)
      .then(() => {
        if (!href) return

        const ac = window?._1und1datalayer?.[2]?.campaign?.lasttouchactioncode
        if (ac && ac.length > 5) {
          href = setQueryInUrl(href, { ac })
        }

        location.href = href
      })
      .finally(() => setBusy(false))

    return onClick && onClick(e)
  }

  return (
    <Button {...props} className={className} onClick={onClickHandler}>
      {children}
    </Button>
  )
}

AddToCartButton.propTypes = {
  ...Button.propTypes,
  text: PropTypes.string,

  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['article', 'bundle']).isRequired,
      id: PropTypes.string.isRequired,
      amount: PropTypes.number,
      properties: PropTypes.object
    })
  ),
  onClick: PropTypes.func
}

AddToCartButton.defaultProps = {
  items: []
}
